<ion-header class="ion-no-border">
    <ion-toolbar>
        <ion-title>
            Charge
        </ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <div class="form-wrapper">
        <ion-card class="charge-input-form">
            <ng-container *ngIf="!transaction_intent_id">
                <ion-card-header>
                    <ion-card-title>Charge customer</ion-card-title>
                </ion-card-header>
                <ion-card-content>
                    <ion-item lines="none" detail="false" class="ion-text-wrap">
                        <ion-label>Code</ion-label>
                        <ion-input type="tel" inputmode="decimal" maxlength="6" #code_input [(ngModel)]="code"></ion-input>
                    </ion-item>
                    <ion-item lines="none" detail="false">
                        <ion-label>Amount</ion-label>
                        <ion-input type="tel" inputmode="decimal" maxlength="10" [(ngModel)]="price"></ion-input>
                    </ion-item>
                    <ion-item text-center button="true" lines="none" detail="false" (click)="charge()" class="button">
                        <ion-label>Charge</ion-label>
                    </ion-item>
                </ion-card-content>
            </ng-container>
            <ng-container *ngIf="transaction_intent_id">
                <ion-card-header>
                    <ion-card-title>Awaiting approval</ion-card-title>
                </ion-card-header>
                <div class="spinner-wrapper">
                    <ion-spinner name="lines-small"></ion-spinner>
                </div>
                <ion-item text-center button="true" lines="none" detail="false" (click)="presentCancelTransactionConfirmation()" class="button">
                    <ion-label>Cancel</ion-label>
                </ion-item>
            </ng-container>
        </ion-card>
        <p>Tip: Bookmark this page in your browser so you can access it quickly</p>
    </div>
</ion-content>
